import React from "react";
import { CrewPilotModuleShell } from "../CrewPilotModuleShell";
import { PAGE_LAYOUT } from "../../layout/pageLayout";
import { AdminTradesPanel } from "./panels/AdminTradesPanel";

export function AdminTradesScreen({ onBack }) {
  return (
    <CrewPilotModuleShell
      title="Trades"
      subtitle="Company trade catalog for payroll rate resolution"
      sectionLabel="Payroll"
      onBack={onBack}
      layout={PAGE_LAYOUT.COMMAND}
    >
      <AdminTradesPanel />
    </CrewPilotModuleShell>
  );
}
